import { createAxiosInstance } from '@goparrot/common';
import { PaymentCardFacade } from '@goparrot/payment-sdk';
import { axiosConfig, getInterceptors, handleResponseFail, requestInterceptor, responseInterceptor } from '@webstore-monorepo/shared/contexts/axios-provider';

export const axiosPaymentConfig = { ...axiosConfig, axiosConfig: { ...axiosConfig.axiosConfig, baseURL: `${window.WEBSTORE_GATEWAY_URL}/payment` } };
export const api = createAxiosInstance(axiosPaymentConfig);
api.interceptors.request.use(requestInterceptor);
api.interceptors.response.use(responseInterceptor, handleResponseFail);
export const paymentCardsApi = new PaymentCardFacade(axiosPaymentConfig, getInterceptors());
